import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_2 = { class: "col-11" }
const _hoisted_3 = ["onClick", "onKeyup"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  class: "row h-100",
  ref: "elDialog"
}
const _hoisted_6 = { class: "col-lg-5 col-xl-6 position-relative h-lg-100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "service-logo img-fluid",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169 33.4",
    width: "169",
    height: "33.4"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      y: "1.2",
      width: "169",
      height: "31",
      style: {"fill":"#e60026"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M28.51,15.96c-.05,.24-.12,.46-.2,.68l-1.86,5.25c-.13,.36-.39,.54-.76,.54-.18,0-.35-.06-.49-.18s-.25-.27-.31-.45l-1.29-3.52-1.29,3.52c-.07,.18-.17,.33-.3,.45-.14,.12-.3,.18-.48,.18s-.34-.05-.48-.14c-.14-.1-.24-.23-.3-.39l-1.86-5.25c-.08-.22-.14-.44-.2-.68-.05-.24-.08-.48-.08-.74v-2.71c0-.22,.08-.41,.25-.57,.16-.16,.36-.24,.58-.24s.41,.08,.58,.24c.16,.16,.25,.35,.25,.57v2.71c0,.32,.05,.6,.14,.83l1.12,3.09,1.29-3.16c.06-.18,.17-.33,.31-.45s.31-.18,.49-.18,.35,.06,.49,.18,.25,.27,.31,.45l1.29,3.16,1.12-3.09c.09-.23,.14-.51,.14-.83v-2.71c0-.22,.08-.41,.25-.57,.16-.16,.36-.24,.58-.24s.41,.08,.58,.24c.16,.16,.25,.35,.25,.57v2.71c0,.26-.03,.5-.08,.74",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M41.68,13.64c-.16-.4-.39-.74-.69-1.02-.29-.28-.64-.5-1.05-.64-.4-.15-.84-.22-1.31-.22h-1.93c-.46,0-.89,.07-1.29,.22-.4,.15-.75,.36-1.05,.64-.29,.28-.53,.61-.7,1.01-.17,.4-.25,.85-.25,1.36v4.15c0,.51,.08,.97,.25,1.36,.17,.4,.4,.73,.7,1.01,.29,.28,.64,.49,1.05,.63,.4,.15,.84,.22,1.29,.22h1.93c.47,0,.91-.07,1.31-.22s.75-.36,1.05-.64c.29-.28,.52-.62,.69-1.02,.16-.4,.24-.85,.24-1.35v-4.15c0-.5-.08-.95-.24-1.35h0Zm-1.4,5.51c0,.54-.14,.94-.43,1.21-.29,.27-.69,.4-1.21,.4h-1.93c-.5,0-.9-.13-1.2-.4s-.45-.67-.45-1.21v-4.15c0-.54,.15-.94,.45-1.21s.7-.4,1.2-.4h1.93c.52,0,.93,.13,1.21,.4,.29,.27,.43,.67,.43,1.21v4.15Z",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M76.01,13.62c-.16-.4-.39-.73-.69-1.01-.29-.28-.64-.49-1.05-.64-.41-.15-.84-.22-1.31-.22h-1.93c-.46,0-.89,.07-1.29,.22-.4,.15-.75,.36-1.05,.64-.29,.28-.53,.61-.7,1.01-.17,.4-.25,.85-.25,1.36v4.15c0,.51,.08,.97,.25,1.36,.17,.4,.4,.73,.7,1.01,.29,.28,.64,.49,1.05,.63,.4,.15,.84,.22,1.29,.22h2.92c.22,0,.41-.08,.58-.24,.16-.16,.24-.35,.24-.57s-.08-.41-.24-.57c-.16-.16-.36-.24-.58-.24h-2.92c-.5,0-.9-.13-1.2-.4-.3-.27-.45-.67-.45-1.21v-1.61h6.04c.22,0,.41-.08,.58-.24,.16-.16,.24-.35,.24-.57v-1.73c0-.51-.08-.97-.24-1.36h0Zm-1.4,2.3h-5.22v-.92c0-.54,.15-.94,.45-1.21,.3-.27,.7-.4,1.2-.4h1.93c.52,0,.93,.13,1.21,.4,.29,.27,.43,.67,.43,1.21v.92Z",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M89.4,22.21c-.16,.14-.36,.21-.58,.21-.2,0-.38-.07-.56-.21s-.26-.34-.26-.6v-6.63c0-.54-.14-.94-.43-1.21s-.69-.4-1.21-.4h-3.58v8.22c0,.27-.08,.47-.25,.62-.16,.14-.36,.21-.58,.21-.2,0-.38-.07-.56-.21s-.26-.34-.26-.6V12.57c0-.27,.08-.47,.25-.6,.16-.13,.36-.2,.58-.2h4.4c.47,0,.91,.07,1.31,.22,.4,.15,.75,.36,1.05,.64,.29,.28,.52,.62,.69,1.02,.16,.4,.25,.85,.25,1.35v6.61c0,.27-.08,.47-.25,.62",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M113.63,13.62c-.16-.4-.39-.73-.69-1.01-.29-.28-.64-.49-1.05-.64-.4-.15-.84-.22-1.31-.22h-1.93c-.46,0-.89,.07-1.29,.22-.4,.15-.75,.36-1.05,.64-.29,.28-.53,.61-.7,1.01-.17,.4-.25,.85-.25,1.36v4.15c0,.51,.08,.97,.25,1.36,.17,.4,.4,.73,.7,1.01,.29,.28,.64,.49,1.05,.63,.4,.15,.84,.22,1.29,.22h2.92c.22,0,.41-.08,.58-.24,.16-.16,.24-.35,.24-.57s-.08-.41-.24-.57c-.16-.16-.36-.24-.58-.24h-2.92c-.5,0-.9-.13-1.2-.4-.3-.27-.45-.67-.45-1.21v-1.61h6.04c.22,0,.41-.08,.58-.24,.16-.16,.24-.35,.24-.57v-1.73c0-.51-.08-.97-.24-1.36h0Zm-1.4,2.3h-5.22v-.92c0-.54,.15-.94,.45-1.21,.3-.27,.7-.4,1.2-.4h1.93c.52,0,.93,.13,1.21,.4,.29,.27,.43,.67,.43,1.21v.92Z",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M123.49,10.31c-.16,.16-.36,.24-.58,.24h-1.64c-.22,0-.41-.08-.58-.24-.16-.16-.25-.35-.25-.57v-.23c0-.22,.08-.41,.25-.57,.16-.16,.36-.24,.58-.24h1.64c.22,0,.41,.08,.58,.24,.16,.16,.24,.35,.24,.57v.23c0,.22-.08,.41-.24,.57",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M125.36,21.56c0,.19-.07,.37-.21,.55-.14,.17-.34,.26-.62,.26h-4.9c-.27,0-.48-.08-.62-.24s-.21-.35-.21-.57c0-.19,.07-.37,.21-.55,.14-.17,.34-.26,.62-.26h1.63v-7.38h-1.63c-.27,0-.48-.08-.62-.24s-.21-.35-.21-.57c0-.19,.07-.37,.21-.55,.14-.17,.34-.26,.62-.26h2.45c.22,0,.41,.08,.58,.24,.16,.16,.25,.35,.25,.57v8.19h1.63c.27,0,.48,.08,.62,.24s.21,.35,.21,.57",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M138.24,12c-.16-.16-.36-.24-.58-.24h-4.4c-.46,0-.89,.07-1.29,.22-.4,.15-.75,.36-1.05,.63-.29,.28-.53,.61-.7,1.01-.17,.4-.25,.85-.25,1.36v4.15c0,.51,.08,.97,.25,1.36,.17,.4,.4,.73,.7,1.01,.29,.28,.64,.49,1.05,.63,.4,.15,.84,.22,1.29,.22h3.58v.81c0,.54-.15,.94-.45,1.21-.3,.27-.7,.4-1.2,.4h-2.27c-.22,0-.41,.08-.58,.24-.16,.16-.24,.35-.24,.57s.08,.41,.24,.57,.36,.24,.58,.24h2.27c.46,0,.89-.07,1.29-.22,.41-.15,.75-.36,1.05-.63,.29-.28,.53-.61,.7-1.01s.25-.85,.25-1.36V12.57c0-.22-.08-.41-.25-.57h0Zm-1.4,8.75h-3.58c-.5,0-.89-.13-1.19-.4s-.45-.67-.45-1.21v-4.15c0-.54,.15-.94,.45-1.21s.7-.4,1.19-.4h3.58v7.38h0Z",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M152.27,22.21c-.16,.14-.36,.21-.58,.21-.2,0-.38-.07-.56-.21s-.27-.34-.27-.6v-6.63c0-.54-.14-.94-.43-1.21s-.69-.4-1.21-.4h-3.58v8.22c0,.27-.08,.47-.25,.62-.16,.14-.36,.21-.58,.21-.2,0-.38-.07-.56-.21-.17-.14-.26-.34-.26-.6V9.45c0-.27,.08-.47,.24-.6s.36-.2,.58-.2c.2,0,.38,.07,.56,.2s.27,.34,.27,.6v2.31h3.58c.47,0,.91,.07,1.31,.22,.4,.15,.75,.36,1.05,.64,.29,.28,.52,.62,.68,1.02,.16,.4,.25,.85,.25,1.35v6.61c0,.27-.08,.47-.25,.62",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M157.62,11.75v-2.54c0-.27,.08-.47,.25-.61,.16-.13,.36-.2,.58-.2,.2,0,.38,.07,.56,.2s.26,.34,.26,.61v2.54h2.7c.27,0,.48,.08,.62,.24s.21,.35,.21,.57c0,.19-.07,.37-.21,.55s-.34,.26-.62,.26h-2.7v5.76c0,.54,.14,.94,.43,1.21,.29,.27,.69,.4,1.21,.4h1.76c.22,0,.41,.08,.58,.24,.16,.16,.25,.35,.25,.57s-.08,.41-.25,.57c-.16,.16-.36,.24-.58,.24h-1.76c-.47,0-.9-.07-1.3-.22-.4-.15-.74-.36-1.04-.64-.29-.28-.53-.62-.7-1.02s-.25-.85-.25-1.35v-5.76",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M57.78,11.76v-2.54c0-.27,.08-.47,.25-.61,.16-.13,.36-.2,.58-.2,.2,0,.38,.07,.56,.2s.26,.34,.26,.61v2.54h2.7c.27,0,.48,.08,.62,.24s.21,.35,.21,.57c0,.19-.07,.37-.21,.55s-.34,.26-.62,.26h-2.7v5.77c0,.54,.14,.94,.43,1.21s.69,.4,1.21,.4h1.76c.22,0,.41,.08,.58,.24,.16,.16,.25,.35,.25,.57s-.08,.41-.25,.57c-.16,.16-.36,.24-.58,.24h-1.76c-.47,0-.9-.07-1.3-.22-.4-.15-.74-.36-1.04-.64-.29-.28-.53-.62-.7-1.02-.17-.4-.25-.85-.25-1.34v-5.77",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.5,11.76v-2.54c0-.27,.08-.47,.25-.61,.16-.13,.36-.2,.58-.2,.2,0,.38,.07,.56,.2s.26,.34,.26,.61v2.54h2.7c.27,0,.48,.08,.62,.24s.21,.35,.21,.57c0,.19-.07,.37-.21,.55-.14,.17-.34,.26-.62,.26h-2.7v5.77c0,.54,.14,.94,.43,1.21s.69,.4,1.21,.4h1.76c.22,0,.41,.08,.58,.24,.16,.16,.25,.35,.25,.57s-.08,.41-.25,.57c-.16,.16-.36,.24-.58,.24h-1.76c-.47,0-.9-.07-1.3-.22-.4-.15-.74-.36-1.04-.64-.29-.28-.53-.62-.7-1.02s-.25-.85-.25-1.34v-5.77",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick", "onKeyup"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "col-lg-7 col-xl-6" }
const _hoisted_12 = { class: "position-relative h-100" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.servicesItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", {
              class: _normalizeClass(`list-unstyled ${_ctx.cssClass}-main-list`)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesItems, (service) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(`list-inline-item ${_ctx.cssClass}-main-item`)
                }, [
                  _createElementVNode("div", {
                    tabindex: "0",
                    class: _normalizeClass(`${_ctx.cssClass}-main-item-text`),
                    onClick: ($event: any) => (_ctx.openModal(service.id)),
                    onKeyup: _withKeys(($event: any) => (_ctx.openModal(service.id)), ["enter"])
                  }, [
                    _createElementVNode("span", {
                      innerHTML: service.title
                    }, null, 8, _hoisted_4)
                  ], 42, _hoisted_3)
                ], 2))
              }), 256))
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.modalVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisible) = $event)),
      "append-to-body": true,
      "custom-class": _ctx.cssClass + '-dialog',
      "close-on-press-escape": true,
      "before-close": _ctx.close,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(`${_ctx.cssClass}-dialog-logo`)
            }, _hoisted_8, 2),
            _createElementVNode("div", {
              class: _normalizeClass(`${_ctx.cssClass}-dialog-navigation`)
            }, [
              _createElementVNode("ul", {
                class: _normalizeClass(`list-unstyled ${_ctx.cssClass}-dialog-navigation-list`)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesItems, (service) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(`list-inline-item ${_ctx.cssClass}-dialog-navigation-item`)
                  }, [
                    _createElementVNode("div", {
                      tabindex: "0",
                      class: _normalizeClass([`${_ctx.cssClass}-dialog-navigation-item-text`, { 'active' : service.id === _ctx.activeServiceId }]),
                      onClick: ($event: any) => (_ctx.openModal(service.id)),
                      onKeyup: _withKeys(($event: any) => (_ctx.openModal(service.id)), ["enter"])
                    }, [
                      _createElementVNode("span", {
                        innerHTML: service.title
                      }, null, 8, _hoisted_10)
                    ], 42, _hoisted_9)
                  ], 2))
                }), 256))
              ], 2)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass([`${_ctx.cssClass}-dialog-content`,
                       {'ce-services-dialog-content--change' : _ctx.initChange}])
            }, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.servicesItems)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.servicesItems, (service, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass([`${_ctx.cssClass}-dialog-content-item`]),
                        key: index
                      }, [
                        _createVNode(_Transition, { name: "fade-services" }, {
                          default: _withCtx(() => [
                            (service.id === _ctx.activeServiceId)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass([`${_ctx.cssClass}-dialog-content-item-inner`])
                                }, [
                                  (service.title)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(`${_ctx.cssClass}-dialog-content-title display-1`)
                                      }, [
                                        _createElementVNode("span", {
                                          innerHTML: service.title
                                        }, null, 8, _hoisted_13)
                                      ], 2))
                                    : _createCommentVNode("", true),
                                  (service.text)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        innerHTML: service.text,
                                        class: _normalizeClass(`${_ctx.cssClass}-dialog-content-text`)
                                      }, null, 10, _hoisted_14))
                                    : _createCommentVNode("", true)
                                ], 2))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ], 2))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["modelValue", "custom-class", "before-close"])
  ], 64))
}